import React from "react";
import { Row, Col } from "react-bootstrap";
import { FiSliders, FiInfo } from "react-icons/fi";

const SettlementPreferencesSection = ({
  formData,
  handleChange,
  handleCheckboxChange
}) => {
  return (
    <div className="bma-card">
      <div className="bma-card-body">
        <div className="d-flex align-items-center gap-2 mb-3">
          <div className="bma-icon-circle"><FiSliders /></div>
          <h2 className="bma-card-title">3. Settlement Preferences</h2>
        </div>

        <Row className="g-3">
          {/* Settlement Frequency */}
          <Col md={12}>
            <label className="bma-label">Settlement Frequency <span className="req">*</span></label>
            <div className="bma-radio-group">
              <label className="bma-radio-label">
                <input type="radio" name="settlement_frequency" value="Per Project" checked={formData.settlement_frequency === "Per Project"} onChange={handleChange} /> Per Project
              </label>
              <label className="bma-radio-label">
                <input type="radio" name="settlement_frequency" value="Weekly" checked={formData.settlement_frequency === "Weekly"} onChange={handleChange} /> Weekly
              </label>
              <label className="bma-radio-label">
                <input type="radio" name="settlement_frequency" value="15 Days" checked={formData.settlement_frequency === "15 Days"} onChange={handleChange} /> 15 Days
              </label>
              <label className="bma-radio-label">
                <input type="radio" name="settlement_frequency" value="Monthly" checked={formData.settlement_frequency === "Monthly"} onChange={handleChange} /> Monthly
              </label>
            </div>
          </Col>

          {/* Weekly Day Select */}
          <Col md={3}>
            <label className="bma-label">Settlement Day (For Weekly) <span className="req">*</span></label>
            <select name="settlement_day_weekly" className="bma-select" value={formData.settlement_day_weekly} onChange={handleChange}>
              <option value="Select day">Select day</option>
              <option value="Monday">Monday</option>
              <option value="Tuesday">Tuesday</option>
              <option value="Wednesday">Wednesday</option>
              <option value="Thursday">Thursday</option>
              <option value="Friday">Friday</option>
              <option value="Saturday">Saturday</option>
              <option value="Sunday">Sunday</option>
            </select>
          </Col>

          {/* Monthly Day Select */}
          <Col md={3}>
            <label className="bma-label">Settlement Day (For Monthly) <span className="req">*</span></label>
            <select name="settlement_day_monthly" className="bma-select" value={formData.settlement_day_monthly} onChange={handleChange}>
              <option value="Select day of month">Select day of month</option>
              <option value="1st">1st of Month</option>
              <option value="5th">5th of Month</option>
              <option value="10th">10th of Month</option>
              <option value="15th">15th of Month</option>
              <option value="20th">20th of Month</option>
              <option value="25th">25th of Month</option>
              <option value="30th">30th / End of Month</option>
            </select>
          </Col>

          {/* Advance Days */}
          <Col md={3}>
            <label className="bma-label">Settlement Advance Days (Optional)</label>
            <input type="number" name="settlement_advance_days" className="bma-input" placeholder="Enter number of days" value={formData.settlement_advance_days} onChange={handleChange} />
          </Col>

          {/* TDS Applicable Checkbox & Value */}
          <Col md={3}>
            <label className="bma-label d-flex align-items-center gap-1">
              TDS Applicable <FiInfo size={14} style={{ color: "#94a3b8" }} title="Check if TDS deduction applies" />
            </label>
            <div className="d-flex align-items-center gap-2">
              <input
                type="checkbox"
                id="is_tds_applicable"
                name="is_tds_applicable"
                checked={formData.is_tds_applicable}
                onChange={handleCheckboxChange}
                style={{ width: "20px", height: "38px", cursor: "pointer", accentColor: "#2563eb", flexShrink: 0 }}
              />
              {formData.is_tds_applicable && (
                <div className="position-relative w-100">
                  <input
                    type="number"
                    step="0.01"
                    name="tds_value"
                    className="bma-input pe-4"
                    placeholder="TDS %"
                    value={formData.tds_value}
                    onChange={handleChange}
                  />
                  <span className="position-absolute end-0 top-50 translate-middle-y me-2" style={{ color: "#94a3b8", fontWeight: "600", fontSize: "12px" }}>%</span>
                </div>
              )}
            </div>
          </Col>

          <Col md={12}><hr style={{ borderColor: "#24283b", margin: "8px 0" }} /></Col>

          {/* Commission Mode & Amount */}
          <Col md={3}>
            <label className="bma-label">Commission Mode <span className="req">*</span></label>
            <div className="bma-radio-group">
              <label className="bma-radio-label">
                <input type="radio" name="commission_type" value="Percentage" checked={formData.commission_type === "Percentage"} onChange={handleChange} /> Percentage (%)
              </label>
              <label className="bma-radio-label">
                <input type="radio" name="commission_type" value="Fixed" checked={formData.commission_type === "Fixed"} onChange={handleChange} /> Fixed Amount (₹)
              </label>
            </div>
          </Col>

          <Col md={3}>
            <label className="bma-label">
              {formData.commission_type === "Percentage" ? "Commission Rate (%)" : "Commission Amount (₹)"} <span className="req">*</span>
            </label>
            <input
              type="number"
              step="0.01"
              name="commission_value"
              className="bma-input"
              placeholder={formData.commission_type === "Percentage" ? "10" : "10000"}
              value={formData.commission_value}
              onChange={handleChange}
              required
            />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SettlementPreferencesSection;